interface LogoProps {
  size?: number;
  className?: string;
}

/**
 * Voicing mark: a rounded tile with a voice waveform.
 * Theme-aware: tile uses the contrast role, bars use the accent.
 */
export function Logo({ size = 24, className }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      className={className}
      aria-hidden="true"
    >
      <rect width="128" height="128" rx="28" fill="var(--contrast)" />
      <rect x="27" y="50" width="10" height="28" rx="5" fill="var(--primary)" />
      <rect x="43" y="38" width="10" height="52" rx="5" fill="var(--primary)" />
      <rect x="59" y="26" width="10" height="76" rx="5" fill="var(--primary-hover)" />
      <rect x="75" y="38" width="10" height="52" rx="5" fill="var(--primary)" />
      <rect x="91" y="50" width="10" height="28" rx="5" fill="var(--primary)" />
    </svg>
  );
}
